import axios, { AxiosInstance } from "axios";
import { BASE_URL, TIMEOUT } from "../constants/constants";
export const axiosInstance = (): AxiosInstance => {
  const config = axios.create({
    baseURL: BASE_URL,
    timeout: TIMEOUT,
  });
  return config;
};
export const axiosGears = axiosInstance();
